import React from "react";

const base =
  "rounded-xl border border-white dark:border-slate-900/70 bg-white dark:bg-slate-900/60 px-3 py-2 text-slate-800 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500 shadow-inner transition focus:border-indigo-300 dark:focus:border-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-200 dark:focus-visible:ring-indigo-800/50 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:bg-slate-100 dark:disabled:bg-slate-800 disabled:opacity-70";

const Input = React.forwardRef(function Input({ className = "", ...rest }, ref) {
  return <input ref={ref} className={`${base} ${className}`} {...rest} />;
});

export default Input;
